var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup434(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H55V54H0z",
    transform: "translate(0 -.262) translate(0 .262)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#61805b",
    d: "M24.316 3.695L21.408.788A2.69 2.69 0 0 0 19.507 0H9.862a2.69 2.69 0 0 0-2.69 2.69v2.69H2.69A2.69 2.69 0 0 0 0 8.069V26a2.69 2.69 0 0 0 2.69 2.69h12.551a2.69 2.69 0 0 0 2.69-2.69v-2.69h4.483a2.69 2.69 0 0 0 2.69-2.69V5.6a2.69 2.69 0 0 0-.788-1.9zM14.905 26H3.026a.336.336 0 0 1-.336-.336V8.405a.336.336 0 0 1 .336-.336h4.146v12.552a2.69 2.69 0 0 0 2.69 2.69h5.379v2.353a.336.336 0 0 1-.336.336zm7.172-5.379H10.2a.336.336 0 0 1-.336-.336V3.026a.336.336 0 0 1 .336-.336h5.94v4.931a1.345 1.345 0 0 0 1.345 1.345h4.931v11.318a.336.336 0 0 1-.336.336zm.336-14.345h-3.586V2.69h.54a.336.336 0 0 1 .238.1l2.71 2.71a.336.336 0 0 1 .1.238z",
    transform: "translate(0 -.262) translate(14.644 12.913)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup434);
export default __webpack_public_path__ + "static/media/Group 434.f6c9fdea30d6fdb44ffd4df2d809c98e.svg";
export { ForwardRef as ReactComponent };